import React from 'react';
import { UsersIcon } from 'lucide-react';
export function LiveVisitorCounter() {
  return <div className="fixed bottom-4 left-4 z-40 bg-white shadow-md rounded-full py-1 px-3 flex items-center text-xs font-medium text-gray-700 border border-gray-200" data-id="element-148">
      <UsersIcon className="h-3 w-3 text-green-600 mr-1" data-id="element-149" />
      <span data-id="element-150">
        <span className="font-bold" data-id="element-151">
          {Math.floor(Math.random() * (45 - 28 + 1)) + 28}
        </span>{' '}
        personas viendo ahora
      </span>
    </div>;
}